import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/features", label: "阅读功能" },
  { to: "/ranking", label: "漫画排行" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const doSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (keyword.trim()) {
      navigate(`/ranking?q=${encodeURIComponent(keyword.trim())}`);
      setOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-xl"></i>
          </span>
          <span className="font-heading text-xl leading-none text-foreground-950">
            新新漫画网
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={doSearch} className="relative">
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 作者"
              className="h-9 w-52 rounded-full border border-background-300 bg-background-100 pl-9 pr-3 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
          </form>
          <Link
            to="/ranking"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            开始阅读
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-800"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <form onSubmit={doSearch} className="relative mt-3">
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 作者"
              className="h-10 w-full rounded-full border border-background-300 bg-background-100 pl-10 pr-3 text-sm outline-none focus:border-primary-400"
            />
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-foreground-400"></i>
          </form>
        </div>
      )}
    </header>
  );
}